export function isPromise(value: Promise<any>): boolean {
  return !!value?.then;
}
